module.exports = __webpack_public_path__ + "static/media/welcome-hero.d690ff47.jpg";